export default __webpack_public_path__ + "static/media/waReward.ec8cd01b.png";